import { Checkbox } from "primereact/checkbox"
import { InputText } from "primereact/inputtext"
import { FieldErrors, UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { Modelo390Form } from "./DeclaracionModelo390"

export const DatosEstadisticos = ({
  setValue,
  watch,
  errors,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  watch: UseFormWatch<$TSMigrationFixMe>
  errors: FieldErrors<Modelo390Form>
}) => {
  const { t } = useTranslation()
  const values = watch()

  const fieldsDatosEstadisticos: {
    row: {
      code: $TSMigrationFixMe
      value: $TSMigrationFixMe
    }[]
  }[] = [
    {
      row: [
        {
          code: "actividadOtra1Descripcion",
          value: values?.actividadOtra1Descripcion,
        },
        {
          code: "actividadOtra1Codigo",
          value: values?.actividadOtra1Codigo,
        },
        {
          code: "actividadOtra1Epigrafe",
          value: values?.actividadOtra1Epigrafe,
        },
      ],
    },
    {
      row: [
        {
          code: "actividadOtra2Descripcion",
          value: values?.actividadOtra2Descripcion,
        },
        {
          code: "actividadOtra2Codigo",
          value: values?.actividadOtra2Codigo,
        },
        {
          code: "actividadOtra2Epigrafe",
          value: values?.actividadOtra2Epigrafe,
        },
      ],
    },
    {
      row: [
        {
          code: "actividadOtra3Descripcion",
          value: values?.actividadOtra3Descripcion,
        },
        {
          code: "actividadOtra3Codigo",
          value: values?.actividadOtra3Codigo,
        },
        {
          code: "actividadOtra3Epigrafe",
          value: values?.actividadOtra3Epigrafe,
        },
      ],
    },
    {
      row: [
        {
          code: "actividadOtra4Descripcion",
          value: values?.actividadOtra4Descripcion,
        },
        {
          code: "actividadOtra4Codigo",
          value: values?.actividadOtra4Codigo,
        },
        {
          code: "actividadOtra4Epigrafe",
          value: values?.actividadOtra4Epigrafe,
        },
      ],
    },
    {
      row: [
        {
          code: "actividadOtra5Descripcion",
          value: values?.actividadOtra5Descripcion,
        },
        {
          code: "actividadOtra5Codigo",
          value: values?.actividadOtra5Codigo,
        },
        {
          code: "actividadOtra5Epigrafe",
          value: values?.actividadOtra5Epigrafe,
        },
      ],
    },
  ]

  return (
    <div className='tw-px-4 tw-pb-4 tw-space-y-4 tw-bg-white'>
      <div className='tw-grid tw-grid-cols-3 tw-gap-4 tw-items-center tw-border-b tw-font-medium tw-text-sm tw-pb-2'>
        <div>{t("taxSummary.declaracion.datosEstadisticos.text1")}</div>
        <div>{t("taxSummary.declaracion.datosEstadisticos.text2")}</div>
        <div>
          <a
            href='https://sede.agenciatributaria.gob.es/Sede/ayuda/herramientas-asistencia-virtual/herramientas-asistencia-virtual-censos-iae/buscador-actividades-economicas-obligaciones-tributarias.html'
            target='_blank'
            rel='noopener noreferrer'
            className='tw-text-info hover:tw-underline'
          >
            {t("taxSummary.declaracion.liquidacionModelo.box30")}
          </a>
        </div>
      </div>

      {/* Fila principal */}
      <div className='tw-grid tw-grid-cols-3 tw-gap-4 tw-items-start tw-pt-2'>
        <div className='tw-flex tw-flex-col'>
          <InputText
            className={`tw-w-full ${
              errors?.actividadPrincipalDescripcion?.message
                ? "!tw-border-danger"
                : ""
            }`}
            value={values?.actividadPrincipalDescripcion}
            onChange={(e) =>
              setValue("actividadPrincipalDescripcion", e.target.value)
            }
          />
          <small
            className={`${
              errors?.actividadPrincipalDescripcion?.message
                ? "tw-text-danger"
                : "tw-text-gray-500"
            }`}
          >
            {t("taxSummary.declaracion.datosEstadisticos.text3")}
          </small>
        </div>
        <div className='tw-flex tw-flex-col'>
          <InputText
            className={`tw-w-full ${
              errors?.actividadPrincipalCodigo?.message
                ? "!tw-border-danger"
                : ""
            }`}
            value={values?.actividadPrincipalCodigo}
            onChange={(e) =>
              setValue("actividadPrincipalCodigo", e.target.value)
            }
          />
          <small
            className={`${
              errors?.actividadPrincipalCodigo?.message
                ? "tw-text-danger"
                : "tw-text-gray-500"
            }`}
          >
            {t("taxSummary.declaracion.datosEstadisticos.text3")}
          </small>
        </div>
        <div className='tw-flex tw-flex-col'>
          <InputText
            className={`tw-w-full ${
              errors?.actividadPrincipalEpigrafe?.message
                ? "!tw-border-danger"
                : ""
            }`}
            value={values?.actividadPrincipalEpigrafe}
            onChange={(e) =>
              setValue("actividadPrincipalEpigrafe", e.target.value)
            }
          />
          <small
            className={`${
              errors?.actividadPrincipalEpigrafe?.message
                ? "tw-text-danger"
                : "tw-text-gray-500"
            }`}
          >
            {t("taxSummary.declaracion.datosEstadisticos.text3")}
          </small>
        </div>
      </div>

      {/* Otros */}
      <div className='tw-mt-4'>
        <h4 className='tw-font-medium tw-text-sm'>
          {t("taxSummary.declaracion.datosEstadisticos.text4")}
        </h4>
        {fieldsDatosEstadisticos.map((field, idx) => {
          const key = `otherRow_${idx}`
          return (
            <div
              key={key}
              className='tw-grid tw-grid-cols-3 tw-gap-4 tw-items-start tw-mt-2'
            >
              {field.row.map((col) => (
                <InputText
                  key={col.code}
                  className='tw-w-full'
                  value={col.value}
                  onChange={(e) => setValue(col.code, e.target.value)}
                />
              ))}
            </div>
          )
        })}
      </div>

      {/* Checkbox */}
      <div className='tw-flex tw-items-center tw-gap-4 tw-mt-4'>
        <div className='tw-flex tw-gap-1'>
          <Checkbox
            inputId='operaciones'
            checked={values?.declaracionAnualOperacionesTerceros}
            onChange={(e) =>
              setValue("declaracionAnualOperacionesTerceros", e.target.checked)
            }
          />
          <label
            htmlFor='operaciones'
            className='tw-mb-0 tw-text-sm'
          >
            {t("taxSummary.declaracion.datosEstadisticos.text5")}
          </label>
        </div>
      </div>

      {/* Declaración conjunta */}
      <div className='tw-mt-4 tw-pt-4 tw-border-t'>
        <h4 className='tw-font-medium tw-text-sm'>
          {t("taxSummary.declaracion.datosEstadisticos.text6")}
        </h4>
        <p className='tw-text-sm tw-mb-2'>
          {t("taxSummary.declaracion.datosEstadisticos.text7")}
        </p>

        <div className='tw-grid tw-grid-cols-2 tw-gap-4'>
          <div>
            <label className='tw-text-sm'>
              {t("taxSummary.declaracion.identificacionModelo.nif")}
            </label>
            <InputText
              className='tw-w-full'
              value={values?.declaracionConjuntaNif}
              onChange={(e) =>
                setValue("declaracionConjuntaNif", e.target.value)
              }
            />
          </div>
          <div>
            <label className='tw-text-sm'>
              {t("taxSummary.declaracion.datosEstadisticos.text8")}
            </label>
            <InputText
              className='tw-w-full'
              value={values?.declaracionConjuntaRazonSocial}
              onChange={(e) =>
                setValue("declaracionConjuntaRazonSocial", e.target.value)
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}
